/** @format */

import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, Tooltip } from '@mui/material';
import { DataGrid, frFR } from '@mui/x-data-grid';
import PropTypes from 'prop-types';

function VirtualKitList({
  configs,
  isLoading,
  onEdit,
  paginationModel,
  setPaginationModel,
  rowCount,
  onProcessRowUpdate,
}) {
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      minWidth: 5,
    },
    {
      field: 'type',
      headerName: 'Type',
      flex: 1,
      minWidth: 150,
      valueGetter: ({ row }) => row?.type || '---',
    },
    {
      field: 'title',
      headerName: 'Titre',
      flex: 1,
      minWidth: 150,
      valueGetter: ({ row }) => row?.title || '---',
    },
    {
      field: 'icon',
      headerName: 'Icône',
      flex: 0.8,
      minWidth: 140,
      valueGetter: ({ row }) => row?.icon || '---',
    },
    {
      field: 'is_active',
      headerName: 'Actif',
      flex: 0.4,
      minWidth: 90,
      type: 'boolean',
      editable: true,
    },
    {
      field: 'main_typology',
      headerName: 'Typologie',
      flex: 1,
      minWidth: 150,
      valueGetter: ({ row }) => row?.main_typology?.name || '---',
    },
    {
      field: 'vat_rate',
      headerName: 'TVA',
      flex: 0.5,
      minWidth: 100,
      valueGetter: ({ row }) => (row?.vat_rate ? `${row.vat_rate}` : '---'),
    },
    {
      field: 'questions_count',
      headerName: 'Questions',
      flex: 0.5,
      minWidth: 100,
      valueGetter: ({ row }) =>
        row?.questions_count ?? row?.questions?.length ?? 0,
    },
    {
      field: 'actions',
      headerName: 'Modifier',
      width: 130,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="100%"
        >
          <Tooltip title="Modifier la configuration">
            <IconButton onClick={() => onEdit(params.row)} color="primary">
              <EditIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
      headerAlign: 'center',
    },
  ];

  return (
    <Box sx={{ height: '70vh', width: '100%' }}>
      <DataGrid
        rows={configs}
        columns={columns}
        loading={isLoading}
        pageSizeOptions={[10, 25, 50, 100]}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        paginationMode="server"
        rowCount={rowCount}
        disableRowSelectionOnClick
        processRowUpdate={onProcessRowUpdate}
        experimentalFeatures={{ newEditingApi: true }}
        sortingMode="server"
        localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
      />
    </Box>
  );
}

VirtualKitList.propTypes = {
  configs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
      title: PropTypes.string,
      icon: PropTypes.string,
      is_active: PropTypes.bool,
      main_typology: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        slug: PropTypes.string,
      }),
      vat_rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      is_filter: PropTypes.bool,
      questions_count: PropTypes.number,
      questions: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          question: PropTypes.string,
          order: PropTypes.number,
        }),
      ),
    }),
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  paginationModel: PropTypes.shape({
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
  }).isRequired,
  setPaginationModel: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
  onProcessRowUpdate: PropTypes.func,
};

VirtualKitList.defaultProps = {
  onProcessRowUpdate: undefined,
};

export default VirtualKitList;
